<template>
  <div
    class="modal fade"
    id="modaDetailCompany"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modaDetailCompanyLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="modaDetailCompanyLabel">
            Detail Company
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeModal"
            @click="closeModal"
          ></button>
        </div>
        <div class="modal-body">
          <div class="d-lg-flex">
            <div class="col-lg-8">
              <div class="mb-2">
                <label for="exampleFormControlInput3">Company Code</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput3"
                  placeholder="code"
                  v-model="newData.compcode"
                  disabled
                />
              </div>
              <div class="mb-2">
                <label for="exampleFormControlInput4">Company name</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleFormControlInput4"
                  placeholder="code"
                  v-model="newData.compname"
                  :disabled="!statusEdit"
                />
              </div>
            </div>
            <div class="col px-3">
              <div class="card">
                <div class="card-body">
                  <div class="mb-2">
                    <p style="font-size: 12px">User Created</p>
                    <p style="font-size: 12px; font-weight: 900">
                      {{ newData ? newData.ucreated : "-" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            v-if="statusEdit"
            @click="cancelEdit"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            v-if="statusEdit"
            @click="saveEdit"
          >
            Save
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            v-if="!statusEdit"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="statusEdit = true"
            v-if="!statusEdit"
          >
            Edit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "CompanyDetailComponent",
  props: {
    datas: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      statusEdit: false,
      newData: {},
    };
  },
  watch: {
    datas() {
      this.newData = { ...this.datas };
    },
  },
  methods: {
    ...mapActions({
      update: "Company/update",
    }),
    cancelEdit() {
      this.newData = { ...this.datas };
      this.statusEdit = false;
    },
    closeModal() {
      this.statusEdit = false;
      this.newData = {};
    },
    saveEdit() {
      this.update(this.newData)
        .then(() => {
          const status = this.$store.state.Alert.isAlerts[0].status;
          if (!status) {
            this.statusEdit = true;
          } else {
            this.statusEdit = false;
          }
        })
        .catch(() => {
          this.statusEdit = false;
        });
    },
  },
};
</script>
